import React from 'react';
import { TextField, Label } from '@fluentui/react';

const ArcUpload = (props) => {


    const handleFileChange = (e) => {
      if (e.target.files) {
        const file = e.target.files[0];

            const reader = new FileReader();
            reader.onload = (data) => {
                const fileContent = reader.result;
                const lines = fileContent.split('\n');
                props.changeHandler(props.config.Id, lines);
            }
            reader.readAsText(file,'utf-8');


            //const fileContent = reader.result;
            //const fileContent = await file.text('utf-8');
      }


    };

    return (
        <React.Fragment>
            <Label>{props.config.Label}</Label>
            <TextField type="file" onChange={handleFileChange} ></TextField>
        </React.Fragment>
    )
}

export default ArcUpload;